import { render, staticRenderFns } from "./NewsPanel.vue?vue&type=template&id=5736ca2a&scoped=true"
import script from "./NewsPanel.vue?vue&type=script&lang=js"
export * from "./NewsPanel.vue?vue&type=script&lang=js"
import style0 from "./NewsPanel.vue?vue&type=style&index=0&id=5736ca2a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5736ca2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5736ca2a')) {
      api.createRecord('5736ca2a', component.options)
    } else {
      api.reload('5736ca2a', component.options)
    }
    module.hot.accept("./NewsPanel.vue?vue&type=template&id=5736ca2a&scoped=true", function () {
      api.rerender('5736ca2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/components/NewsPanel.vue"
export default component.exports